export const DEFAULT_FREQUENT_CITIES = {
	'Київ': {
		value: 'м. Київ',
		province: 'Київська обл.',
		label: 'м. Київ (Київська обл.)',
		delivery_city_id: '8d5a980d-391c-11dd-90d9-001a92567626',
		city_id: 'e718a680-4b33-11e4-ab6d-005056801329',
		meta: {
			Area: 'Київська',
			DeliveryCity: '8d5a980d-391c-11dd-90d9-001a92567626',
			MainDescription: 'Київ',
			Region: ''
		}
	},
	'Дніпро': {
		value: 'м. Дніпро',
		province: 'Дніпропетровська обл.',
		label: 'м. Дніпро (Дніпропетровська обл.)',
		delivery_city_id: 'db5c88f0-391c-11dd-90d9-001a92567626',
		city_id: 'e717110a-4b33-11e4-ab6d-005056801329',
		meta: {
			Area: 'Дніпропетровська',
			DeliveryCity: 'db5c88f0-391c-11dd-90d9-001a92567626',
			MainDescription: 'Дніпро',
			Region: ''
		}
	},
	'Одеса': {
		value: 'м. Одеса',
		province: 'Одеська обл.',
		label: 'м. Одеса (Одеська обл.)',
		delivery_city_id: 'db5c88d0-391c-11dd-90d9-001a92567626',
		city_id: 'e71c2a15-4b33-11e4-ab6d-005056801329',
		meta: {
			Area: 'Одеська',
			DeliveryCity: 'db5c88d0-391c-11dd-90d9-001a92567626',
			MainDescription: 'Одеса',
			Region: ''
		}
	},
	'Львів': {
		value: 'м. Львів',
		province: 'Львівська обл.',
		label: 'м. Львів (Львівська обл.)',
		delivery_city_id: 'db5c88f5-391c-11dd-90d9-001a92567626',
		city_id: 'e71abb60-4b33-11e4-ab6d-005056801329',
		meta: {
			Area: 'Львівська',
			DeliveryCity: 'db5c88f5-391c-11dd-90d9-001a92567626',
			MainDescription: 'Львів',
			Region: ''
		}
	},
	'Харків': {
		value: 'м. Харків',
		province: 'Харківська обл.',
		label: 'м. Харків (Харківська обл.)',
		delivery_city_id: 'db5c88e0-391c-11dd-90d9-001a92567626',
		city_id: 'e71f8842-4b33-11e4-ab6d-005056801329',
		meta: {
			Area: 'Харківська',
			DeliveryCity: 'db5c88e0-391c-11dd-90d9-001a92567626',
			MainDescription: 'Харків',
			Region: ''
		}
	}
};
